import React from "react"
import { AnimateWrapper } from "@components/main/animate-wrapper/AnimateWrapper"
import { Cta } from "@components/common/cta/Cta"

import * as s from "./RichText.module.scss"

export const RichText = ({ data, pageContext }) => {
  const { links } = data

  return (
    <AnimateWrapper>
      <div
        className={`${s.RichText} ${
          pageContext &&
          pageContext.slug == "have-a-wonderful-pint" &&
          s.RichText___christmas
        }`}
      >
        <div dangerouslySetInnerHTML={{ __html: data.richText }} />

        {links && (
          <div className={s.Links}>
            {links.map((link, idx) => {
              if (!link.link) return null
              if (!link.link.title || !link.link.url) return null

              return (
                <Cta
                  key={idx}
                  target={link.link.target}
                  title={link.link.title}
                  link={link.link.url}
                  external={link.link.target === "_blank"}
                />
              )
            })}
          </div>
        )}
      </div>
    </AnimateWrapper>
  )
}
